/** Public page handed from the Framer editor to the signed-in review setup. */
export function parseFramerReviewUrl(value) {
    if (!value || value.length > 2000)
        return null;
    try {
        const url = new URL(value);
        const host = url.hostname.toLowerCase().replace(/\.+$/, '');
        if (url.protocol !== 'https:' || url.username || url.password || url.port ||
            !host.includes('.') || host.endsWith('.localhost') || host.endsWith('.local') ||
            host.endsWith('.internal') || host.startsWith('[') || /^\d+(\.\d+){3}$/.test(host))
            return null;
        return url.href;
    }
    catch {
        return null;
    }
}
export function framerReviewHandoffUrl(pageUrl) {
    const valid = parseFramerReviewUrl(pageUrl);
    if (!valid)
        return null;
    const target = new URL('https://app.overlayqa.com/integrations/framer');
    target.searchParams.set('url', valid);
    return target.href;
}
//# sourceMappingURL=framerReview.js.map